module.exports = __webpack_public_path__ + "static/media/todolist.7c672706.png";